import React from 'react';
import PropTypes from 'prop-types';

import './styles/approve_request_actions';

const ApproveRequestActions = ({ selectAll }) => (
  <div className="share-manifest-approve-assets-actions">
    <button
      className="button primary"
      onClick={() => selectAll()}
      type="button"
    >
      {t('Select all')}
    </button>
    <p className="action-guidance">{t('or select individual assets for approval')}</p>
  </div>
);

ApproveRequestActions.propTypes = {
  selectAll: PropTypes.func.isRequired,
};

export default ApproveRequestActions;
